import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    SubmitStatementOptionsApiParameter,
    submitStatementOptionsForm,
} from "@store/Services/StatementOptionsService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

type Parameter = {
    apiParameter: SubmitStatementOptionsApiParameter;
} & HasOnSuccess<any> &
    HasOnError<any>;
type Props = StoreHandlerProps & {
    apiParameter: SubmitStatementOptionsApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.apiParameter;
};

export const SendDataToApi: HandlerType = async props => {
    await submitStatementOptionsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(null);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitStatementOptions = createHandlerChainRunner(chain, "SubmitStatementOptions");
export default submitStatementOptions;
